import { render, staticRenderFns } from "./positionList.vue?vue&type=template&id=b6766e24&scoped=true"
import script from "./positionList.vue?vue&type=script&lang=js"
export * from "./positionList.vue?vue&type=script&lang=js"
import style0 from "./positionList.vue?vue&type=style&index=0&id=b6766e24&prod&lang=scss&scoped=true"
import style1 from "./positionList.vue?vue&type=style&index=1&id=b6766e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6766e24",
  null
  
)

export default component.exports